var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Team1',{attrs:{"team":_vm.team}})
}
var staticRenderFns = []

export { render, staticRenderFns }